import SellerProductsItem from "./SellerProductsItem";

export default SellerProductsItem;
